<template>
  <teleport to="#app">
    <ModalComponent v-model="afficherModale">
      <template #header>Réalisation de la formation</template>
      <template #content>
        <div class="flex flex-wrap flex-gap-4">
          <BasicIconTitleCard
            v-for="(card, index) in cards"
            :key="index"
            v-bind="card"
            :isActive="index === selectedModuleIndex"
            @setActive="() => setActiveCard(index)"
          />
        </div>
      </template>
      <template #actions>
        <BasicButton
          @click="ajouterModule(cards[selectedModuleIndex!]!.typeModule)"
          label="Continuer"
          type="secondary"
          size="large"
          :disabled="selectedModuleIndex === null"
          width="full"
        />
      </template>
    </ModalComponent>
  </teleport>
</template>

<script setup lang="ts">
  import { inject } from 'vue'
  import ModalComponent from '@/features/interface/modal/ModalComponent.vue'
  import { CXPI_MODULES_ACTIONS } from '../useModuleActions'

  const { afficherModale, setActiveCard, ajouterModule, cards, selectedModuleIndex } = inject(CXPI_MODULES_ACTIONS)!
</script>
<style scoped lang="less">
  :deep(.icon--container) {
    width: 45px;
    height: 55px;
  }
</style>
